// =============================================================================
// SWICA Health Frontend Configuration
// =============================================================================

// Project Identity
export const BRDGE_PROJECT_ID = "swica-health"; // Namespaces cookies/localStorage

// Backend Quest/Story Name (must match BRDGE Content admin)
export const QUEST_NAME = "SWICA_HEALTH";
export const STORY_NAME = "";

// Locales
export const AVAILABLE_LOCALES = ["de", "fr", "it"] as const;
export const DEFAULT_LOCALE = "de";

// Legacy flag (keep for compatibility)
export const WITH_DELAY = false;

// =============================================================================
// Feature Flags
// =============================================================================

export const FEATURES = {
  // -------------------------------------------------------------------------
  // Onboarding Flow Configuration
  // -------------------------------------------------------------------------
  onboarding: {
    showWelcome: true, // Show welcome page with consent
    showLegal: false, // Show legal terms (as slide panel from welcome)
    requireConsent: false, // Checkbox required to proceed
    showReady: true, // Show ready/launch page before game
  },

  // -------------------------------------------------------------------------
  // Correct Answer Panel ("Richtig!" screen shown after correct answer)
  // -------------------------------------------------------------------------
  correctPanel: {
    enabled: false, // Show the Richtig! panel between correct answer and next question
  },

  // -------------------------------------------------------------------------
  // Scoring System
  // -------------------------------------------------------------------------
  scoring: {
    enabled: true,
    pointsPerCorrect: 100,
    pointsPerIncorrect: -20,
    allowNegativeScore: true,
    // minScore: null,      // Optional: set to 0 to floor at zero
    // winThreshold: null,  // Optional: for future projects with rewards
  },

  // -------------------------------------------------------------------------
  // Solution Word (letter reveal mechanic)
  // -------------------------------------------------------------------------
  solutionWord: {
    enabled: true,
  },

  // -------------------------------------------------------------------------
  // Client Redirect Configuration
  // -------------------------------------------------------------------------
  redirect: {
    enabled: true,
    clientBaseUrl: "https://www.swica.ch/health-game",
    clientAnchor: "wettbewerb333",
    incomingParamName: "v", // We receive: ?v=VALUE (+ any utm_* params)
    outgoingParamName: "utm_source", // v value is forwarded as utm_source
    voidValue: "void", // When v=void, no contest
  },

  // -------------------------------------------------------------------------
  // BRDGE Journey API Integration
  // -------------------------------------------------------------------------
  journeyApi: {
    enabled: true,
    // Configuration will be loaded from environment variables
  },

  // -------------------------------------------------------------------------
  // Per-question Promo Pages (future - not implemented)
  // -------------------------------------------------------------------------
  promoLandingPage: {
    enabled: false,
  },
} as const;

// Type exports for feature flags
export type Features = typeof FEATURES;
